// frontend/src/components/home/UpdateAccordion.js
import { updates } from "../../data/updates";

export default function UpdateAccordion() {
  return (
    <div className="update-accordion">
      {updates.map((update) => (
        <details className="update-block" key={update.version}>
          <summary className="update-summary">
            <span>
              {update.version} ({update.date})
            </span>
          </summary>

          <ul className="update-change-list">
            {update.changes.map((c) => (
              <li key={c}>{c}</li>
            ))}
          </ul>
        </details>
      ))}
    </div>
  );
}
